module.exports = __webpack_public_path__ + "static/media/clock.4c7f2ca7.png";